// @ts-nocheck
import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import Loader from 'components/atoms/Loader';
import PropTypes from 'prop-types';
import signatureImage from '../../../../../../../Forms/RegisterForm/CustomFormBuilder/RenderFormField/style/signature.png';
import { useClientStyles } from '../../../../Styles';

const SignatureField = ({
  toggleSignaturePad,
  savedSignature,
  isSignatureLoading,
}) => {
  const classes = useClientStyles();
  return (
    <Box mt={1}>
      {savedSignature ? (
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{
            height: { xs: 300, sm: 250 },
            background: '#F5F5F5',
          }}
          className={classes.signWrap}
          p={3}
        >
          {isSignatureLoading ? (
            <Loader />
          ) : (
            <img src={savedSignature} alt="Signature" />
          )}
        </Stack>
      ) : (
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{
            height: { xs: 150, sm: 200 },
          }}
          className={classes.signWrap}
          onClick={toggleSignaturePad}
        >
          <img
            src={signatureImage}
            alt="Signature"
            style={{ width: { xs: '40px', sm: '60px' } }}
          />
          <Typography variant="body2" color="textSecondary">
            Click here to add signature
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export default SignatureField;

SignatureField.propTypes = {
  toggleSignaturePad: PropTypes.func.isRequired,
  savedSignature: PropTypes.string,
  isSignatureLoading: PropTypes.bool,
};
